export enum MultiSelectorVisualization {
  Automatic,
  Dropdown,
}
